
import RcTableViewUtils from '@/portals/shared/table/RcTableViewUtils.js';


import MC from "@/domain/session/MC.js";

export default class CompanyAddressUpdateViewUtils extends RcTableViewUtils {

  constructor(model, tableData) {
    super(model, tableData);
    this.MC = new MC();
  }

    start() {
      super.start();
    }
}